<template>
  <div>
    <div :class="['weChat-box', isEnableNotice && 'enable-notice']" @click="showQrCodeDialog">
      <i class="el-icon-chat-dot-round" />{{ isEnableNotice ? '已开通服务号通知' : '接收服务号通知' }}
    </div>

    <el-dialog
        class="noticePopup"
        :visible.sync="qrCodeDialogShow"
        :close-on-press-escape="false"
        :close-on-click-modal="true"
        width="300px"
    >
      <div class="noticePopupContent">
        <div class="noticeQrArea">
          <div ref="noticeQrCode" class="noticeQrCode">
            <canvas ref="qrCode"></canvas>
          </div>
        </div>
        <div class="noticeDivider"></div>
        <div class="noticeTips">
          <p>1：长按保存二维码至微信内识别关注公众号</p>
          <p>2：需通过本二维码关注公众号，直接关注公众号无法接受上课通知！</p>
        </div>
      </div>
      <div class="dialogCloseBtn" @click="closeQrCodeDialog" />
    </el-dialog>
  </div>
</template>

<script>
import common from "@/utils/common";
import commApiRequest from "@/api/commApiRequest";
export default {
  name: 'NoticeQrCode',
  props: {
    isEnableNotice: {
      type: Boolean,
      default: false
    },
    uid: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      qrCodeImg: require("@/assets/images/An1.png"),
      qrCodeDialogShow: false,
    }
  },
  methods: {
    showQrCodeDialog() {
      const data = {
        flag: 1,
        org_id: this.uid
      }
      commApiRequest('https://publicmessage.tenghuiwangxiao.cn').post('/getQrcode', data).then(res => {
        if(res.data.code === 200){
          this.qrCodeDialogShow = true
          this.$nextTick(() => {
            common.createQrCode(this.$refs.qrCode, res.data.data.url, { width: 200, height: 200 })
          })
        }
      })
    },
    closeQrCodeDialog() {
      this.qrCodeDialogShow = false
      this.$emit('closeQrCodeDialog')
    }
  }
}
</script>

<style scoped>
.weChat-box {
  position: absolute;
  right: 0;
  top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 32px;
  line-height: 32px;
  border-radius: 16px;
  text-align: center;
  color: #fff;
  background: linear-gradient(133deg, #07c160 3%, #00a854 91%);
  cursor: pointer;
}
.enable-notice {
  width: 180px;
  background: linear-gradient(133deg, #e8e8e8 3%, #c8c8c8 91%);
  color: #0b0b0b;
}
.weChat-box i {
  margin-right: 0.1rem;
}
.noticePopup ::v-deep .el-dialog {
  border-radius: 12px;
}
.noticePopup ::v-deep .el-dialog__header {
  display: none;
}
.noticePopup ::v-deep .el-dialog__body {
  padding: 0;
}
.noticePopupContent {
  position: relative;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
}
.noticeQrArea {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 26px 0 22px;
}
.noticeQrCode {
  width: 240px;
  height: 240px;
  padding: 20px;
  box-sizing: border-box;
}
.noticeDivider {
  position: relative;
  border-top: 1px dashed #e8e8e8;
}
.noticeDivider::before,
.noticeDivider::after {
    content: "";
    position: absolute;
    top: -11px;
    width: 22px;
    height: 22px;
    background: #4C4C4C;
    border-radius: 50%;
}

.noticeDivider::before {
    left: -11px;
  }
.noticeDivider::after  {
  right: -11px;
}
.noticeTips {
  padding: 20px;
  font-size: 14px;
  line-height: 1.5;
  color: #7F7F7F;
}
.noticeTips p:nth-child(1) {
  margin-bottom: 12px;
}
.dialogCloseBtn {
  position: absolute;
  bottom: -48px;
  left: calc(50% - 24px);
  width: 48px;
  height: 48px;
  cursor: pointer;
  background: url('@/assets/images/dialog_close_btn.png') no-repeat center center;
  background-size: 100% 100%;
}
</style>
